import bankInfoService from 'services/bank-info'
import { formatNumber } from 'utils/format-number'
import initVanillaSelect from 'components/select-vanilla'
import eventsService from 'services/events'
import bankRateHelper, { BankRateMap, CurrencyBankRate } from 'services/bank-rate'
import directExchangeService from 'services/direct-exchange'

declare let SINGLE_RATE_CURRENCY: string

const $currencySelect = document.querySelector<HTMLSelectElement>('#single-rate-select')
const $table = document.querySelector<HTMLTableSectionElement>('[data-bank-rate-wrapper]')
const $timer = document.querySelector<HTMLSpanElement>('[data-bank-rate-timer]')
const $amount = document.querySelector<HTMLSpanElement>('[data-bank-rate-amount]')
const $profit = document.querySelector<HTMLSpanElement>('[data-bank-rate-profit]')
const $copy = document.querySelector<HTMLDivElement>('[data-bank-rate-copy ]')

init()

function createBankRecord(bankRate: CurrencyBankRate, bankId: string): string {
  return `
      <tr class="bank-rates-table__row">
        <td class="bank-rates-table__cell">${getBankName(bankId)}</td>
        <td class="bank-rates-table__cell">${formatNumber(bankRate.buy, 4)} PLN</td>
        <td class="bank-rates-table__cell">${formatNumber(bankRate.sell, 4)} PLN</td>
        <td class="bank-rates-table__cell">
          ${formatNumber(parseFloat(bankRate.spread), 4)} PLN 
          (${formatNumber((parseFloat(bankRate.spread) / bankRate.sell) * 100, 2)}%)
        </td>
      </tr>
  `
}

function attachFetchTime(time: string): void {
  const [date] = new Date(time)
    .toLocaleDateString('pl', { year: 'numeric', month: '2-digit', day: '2-digit' })
    .split(',')
  $timer.innerText = date.split('.').join('-')
}

function updateProfitElements(calculatedAmount: string, calculatedProfit: string): void {
  $amount.innerText = formatNumber(calculatedAmount, 2)
  $profit.innerText = formatNumber(calculatedProfit, 2)
}

function attachProfitFromBenefitAmount(minimalBenefitAmount: string, worstBankSupported: string): void {
  directExchangeService
    .getCompareResult(
      'BUY',
      minimalBenefitAmount,
      SINGLE_RATE_CURRENCY,
      'PLN',
      bankInfoService.oneByBankId(worstBankSupported).swift, //FIXME: worstBankSupported can be undefined
    )
    .then((betterData) => {
      updateProfitElements(minimalBenefitAmount, betterData.result.profit)
    })
}

function attachProfit(banksRates: BankRateMap): void {
  // FIXME: worstBankSupported undefined if empty API response (for example dev enviroment)
  const worstBankSupported = Object.keys(bankRateHelper.sortBanksBySellRate(banksRates, SINGLE_RATE_CURRENCY)).find(
    (bankid) => bankInfoService.oneByBankId(bankid),
  )

  directExchangeService
    .getCompareResult('BUY', '100', SINGLE_RATE_CURRENCY, 'PLN', bankInfoService.oneByBankId(worstBankSupported).swift) //FIXME: worstBankSupported can be undefined
    .then((data) => {
      if (!data.result.minimalBenefitAmount) {
        $copy.classList.add('is-hidden')
        return
      }

      if (parseFloat(data.result.profit) <= 0) {
        attachProfitFromBenefitAmount(data.result.minimalBenefitAmount, worstBankSupported) //FIXME: worstBankSupported can be undefined
      } else {
        updateProfitElements('100', data.result.profit)
      }

      $copy.classList.remove('is-hidden')
    })
}

function getBankName(bankId: string): string {
  return (
    bankInfoService.oneByBankId(bankId)?.bank_name ||
    bankInfoService.oneByBankId(bankRateHelper.mapIdToSupportedBankId(bankId))?.bank_name ||
    bankId
  )
}

function getBanksFiltered(banks: BankRateMap): BankRateMap {
  const sortedBanks = Object.keys(bankRateHelper.filterBanksByCurrency(banks, SINGLE_RATE_CURRENCY))
    .filter(
      (bankId) =>
        bankInfoService.oneByBankId(bankId) ||
        bankInfoService.oneByBankId(bankRateHelper.mapIdToSupportedBankId(bankId)),
    )
    .sort((a, b) => (getBankName(a).toLowerCase() > getBankName(b).toLowerCase() ? 1 : -1))
  return bankRateHelper.createBankRateMap(sortedBanks, banks)
}

function init() {
  initVanillaSelect()
  eventsService.dispatchCustomEvent('single-rate-select', { value: SINGLE_RATE_CURRENCY })
  window.addEventListener('single-rate-select change', onSelectChange)

  Promise.all([bankRateHelper.fetchBankRates(), bankInfoService.fetchBanks()]).then(([banksRates]) => {
    const { valid_from, ...banks } = banksRates
    attachFetchTime(valid_from)

    const banksFiltered = getBanksFiltered(banks)
    attachProfit(banksFiltered)
    // Remove all childs from SSR
    $table.innerHTML = ''
    for (const bankId in banksFiltered) {
      if (banksFiltered[bankId][SINGLE_RATE_CURRENCY].buy == 0 || banksFiltered[bankId][SINGLE_RATE_CURRENCY].sell == 0)
        continue
      $table.insertAdjacentHTML('beforeend', createBankRecord(banksFiltered[bankId][SINGLE_RATE_CURRENCY], bankId))
    }
  })
}

function onSelectChange(): void {
  const $el = document.querySelector<HTMLElement>(`[data-dropdown-item-value="${$currencySelect.value}"]`)
  window.location.href = $el.dataset.dropdownRedirect
}
